/**
 * Contratos de paginación e historial compartidos en el monorepo.
 *
 * Antes `PageableData` (con `content: any[]`) se duplicaba en ~37 servicios
 * de `shared-data-access`. Centralizamos el shape del backend y el de UI aquí.
 */

/**
 * Página Spring-like tal como viene en `ApiResponse.data`.
 */
export interface PageableDto<T = unknown> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

/**
 * Página ya mapeada para UI / features (items tipados).
 */
export interface PageResponse<T> {
  items: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

/**
 * Fila estándar de historial de acciones
 * (`*HistoryActionResponse` del backend).
 */
export interface HistoryAction {
  id: string | number;
  date: string | Date;
  action: string;
  user: string;
  ip: string;
  device: string;
  browser: string;
  location: string;
}

export type HistoryPageResponse = PageResponse<HistoryAction>;

/**
 * Resultado típico de create/update/delete/status.
 */
export interface MutationResult {
  message: string;
}
